import { useCallback, useEffect, useState } from "react";
import { BasicTable } from "../components/tables/BasicTable";
import { Pagination } from "../components/pagination/Pagination";
import { useNavigate } from "react-router-dom";
import { Search } from "../components/search/Search";
import { useLocation } from "react-router-dom";
import { getAllPlayers } from "../services/playersAPI";
import Loader from "../components/ui/loader";

export const Players = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);

  const handlePlayerClick = (playerID) => {
    navigate(`/player/${playerID}`);
  };

  const columns = [
    { key: "PlayerID", label: "ID", itemID: "PlayerID", clickHandler: handlePlayerClick },
    {
      key: "firstName",
      label: "First Name",
      itemID: "PlayerID",
      clickHandler: handlePlayerClick,
    },
    {
      key: "lastName",
      label: "Last Name",
      itemID: "PlayerID",
      clickHandler: handlePlayerClick,
    },
    {
      key: "position",
      label: "Position",
      itemID: "PlayerID",
      clickHandler: handlePlayerClick,
    },
    {
      key: "shoots",
      label: "Shoots",
      itemID: "PlayerID",
      clickHandler: handlePlayerClick,
    },
    {
      key: "wins",
      label: "Fight Wins",
      itemID: "PlayerID",
      clickHandler: handlePlayerClick,
    },
    {
      key: "losses",
      label: "Fight Losses",
      itemID: "PlayerID",
      clickHandler: handlePlayerClick,
    },
  ];

  const searchCategories = [
    { value: "id", label: "ID" },
    { value: "firstName", label: "First Name" },
    { value: "lastName", label: "Last Name" },
    { value: "position", label: "Position" },
    { value: "shoots", label: "Shoots" },
    { value: "wins", label: "Fight Wins" },
    { value: "losses", label: "Fight Losses" },
  ];

  const [playerData, setPlayerData] = useState([]);
  const [pagination, setPagination] = useState(null);

  const fetchPlayers = useCallback(async () => {
    try {
      setIsLoading(true);
      let response = await getAllPlayers(location.search);
      console.log(response);
      if (response.success) {
        setPlayerData(response.data.players);
        setPagination(response.data.pagination);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, [location.search]);

  useEffect(() => {
    fetchPlayers();
  }, [fetchPlayers]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-[60vh] bg-flyers-black">
        <Loader />
      </div>
    );
  }

  return (
    <div className="bg-flyers-black min-h-screen p-4 sm:p-6 lg:p-8">
      <div className="max-w-7xl mx-auto space-y-6">
        <h1 className="font-heading text-3xl font-black uppercase tracking-wide text-flyers-orange">
          Players
        </h1>
        <Search categories={searchCategories} />
        <BasicTable columns={columns} data={playerData} />
        <Pagination pagination={pagination} />
      </div>
    </div>
  );
};
